import { useDiagramContext } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/contexts/DiagramContext';
import { BoxTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/BoxTone';

interface DiagramBoxProps {
  x: number;
  y: number;
  width: number;
  height?: number;
  tone?: BoxTone;
}

const STRONG_TONES = [BoxTone.YES, BoxTone.MAYBE, BoxTone.ERROR, BoxTone.ANY, BoxTone.HIGHLIGHT];

export const DiagramBox = ({ x, y, width, height = 26, tone = BoxTone.NEUTRAL }: DiagramBoxProps) => {
  const { colors } = useDiagramContext();
  const box = colors.box[tone];

  return (
    <rect
      x={x}
      y={y}
      width={width}
      height={height}
      rx={colors.radius}
      fill={box.fill}
      stroke={box.stroke}
      strokeWidth={STRONG_TONES.includes(tone) ? 2 : 1.2}
      strokeDasharray={box.dash}
    />
  );
};
